export const COLOR_SCHEME = {
  SECONDARY: 'secondary',
  PRIMARY: 'primary'
} as const;

export const ELEMENT_NAMES = [
  'Button',
  'Input',
  'PhoneSearch',
  'Select',
  'TextArea',
  'DataPicker',
  'Banner',
  'PaymentsView',
  'InfoMessage',
  'TransactionsHistory',
  'NoData',
  'Loader',
  'AlertNotification',
  'Notification',
  'PaymentConfigSW',
  'MailNewMessage'
] as const;
